module.exports = __webpack_public_path__ + "img/home-hero.0760db24.jpg";